import { BenefitRedeemPoint } from 'components/loyalty-program/benefit-redeem-point/BenefitRedeemPoint'
import { useLocation, useSearchParams } from 'react-router-dom'
import {
    constructOptionsSelect,
    constructSelectedValue,
    convertErrorMessage,
    getAllQueryParams,
    getObjectName,
    getQueryFilter,
    getSelectedOption,
    setQueryParams,
} from 'utils/utils'
import { INIT_FILTER, INITIAL_DATA_FILTER } from 'configs/loyalty-program/configTableBenefitRedeemPoint'
import { useEffect, useState } from 'react'
import { Alert } from 'avo-ui'
import { ACTION_TYPE } from 'constants/constant'
import {
    INIT_STATE,
    TYPE_BENEFIT,
    FIELD_NAME_DISCOUNT,
    GET_FIELD_NAME,
    FIELD_NAME_GIFT,
} from 'configs/loyalty-program/configFormBenefitRedeemPoint'
import { useFetch } from 'services/useFetch'
import { API_BENEFIT_REDEEM_POINT } from 'services/apiBenefitRedeemPoint'

export const BenefitRedeemPointContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [queryFilter, setQueryFilter] = useState({})
    const [selectedIds, setSelectedIds] = useState([])
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const [benefitRedeemPointDetail, setBenefitRedeemPointDetail] = useState({})
    const [errorForm, setErrorForm] = useState({})
    const { fetching: getBenefitList, data: benefitList, isLoading } = useFetch(API_BENEFIT_REDEEM_POINT.LIST)
    const { fetching: getGiftList } = useFetch(API_BENEFIT_REDEEM_POINT.GIFT_LIST)
    const { fetching: createBenefit, isLoading: isCreating } = useFetch(API_BENEFIT_REDEEM_POINT.CREATE)
    const { fetching: updateBenefit, isLoading: isUpdating } = useFetch(API_BENEFIT_REDEEM_POINT.UPDATE)
    const { fetching: deleteBenefit, isLoading: isDeleting } = useFetch(API_BENEFIT_REDEEM_POINT.DELETE)
    const [options, setOptions] = useState({
        type: TYPE_BENEFIT,
        gift: [],
    })
    const [modal, setModal] = useState({
        filter: false,
        delete: false,
        form: false,
    })

    const isFreeType = (type) => type === 'free-gift'

    useEffect(() => {
        const currentQuery = { ...query }
        const newQueryFilter = { ...INIT_FILTER }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (['types', 'statuses'].includes(key)) {
                const valueOfQuery = item?.split(',')
                newQueryFilter[key] = valueOfQuery
                currentQuery[key] = valueOfQuery
            }
        })
        setQueryFilter(newQueryFilter)
        fetchBenefitRedeemPointList(currentQuery)
    }, [location?.search])

    useEffect(() => {
        const typeValue = benefitRedeemPointDetail?.type?.value
        if (modal?.form && isFreeType(typeValue)) {
            onSearchOptions('', typeValue?.split('-')[1])
        }
    }, [modal])

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search', 'type'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchBenefitRedeemPointList = (item = { ...query }) => {
        getBenefitList(item)
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onHideForm = () => {
        setShowModal({ form: false })
        setErrorForm({})
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const getKeyName = (type) => {
        let name
        if (type === 'free-gift') {
            name = 'gift'
        } else {
            name = 'discount_amount'
        }
        return name
    }

    const onActionRow = ({ item, actionType }) => {
        switch (actionType) {
            case ACTION_TYPE.CREATE:
                setBenefitRedeemPointDetail(INIT_STATE)
                setShowModal({ form: true })
                break
            case ACTION_TYPE.EDIT:
                const { benefit, ...itemRest } = item
                const newItem = {
                    ...INIT_STATE,
                    ...itemRest,
                    type: getSelectedOption(TYPE_BENEFIT, itemRest?.type),
                    [getKeyName(itemRest?.type)]: benefit?.discount_amount ?? {
                        benefit_id: constructSelectedValue(benefit, 'name', 'id'),
                        quantity: benefit?.quantity,
                    },
                }
                setBenefitRedeemPointDetail(newItem)
                setShowModal({ form: true })
                break
            default:
                setShowModal({ delete: true })
        }
    }

    const onFilter = (filter) => {
        const queryFilter = getQueryFilter(filter)
        onChangeQuery({ ...queryFilter, page: 1 })
    }

    const onChangeForm = (e, type) => {
        const { name, value } = e
        const newValue = type ? { [type]: { ...benefitRedeemPointDetail[type], [name]: value } } : { [name]: value }
        setBenefitRedeemPointDetail({ ...benefitRedeemPointDetail, ...newValue })
        if (isFreeType(value?.value)) onSearchOptions('', value?.value?.split('-')[1])
    }

    const onDelete = () => {
        deleteBenefit({ ids: selectedIds }).then(() => {
            setIsResetSelectedItem(!isResetSelectedItem)
            setShowAlert('Benefit Deleted !', { delete: false })
            if (benefitList?.data?.benefits?.length === 1 && Number(query?.page) !== 1) {
                onChangeQuery({ page: 1 })
            } else {
                fetchBenefitRedeemPointList()
            }
        })
    }

    const onSearchOptions = (keyword) => {
        const params = { search: keyword }
        getGiftList(params).then((response) => {
            const newList = constructOptionsSelect(response?.data, 'name', 'id')
            setOptions({ ...options, gift: newList })
        })
    }

    const validateForm = () => {
        const type = benefitRedeemPointDetail?.type?.value
        const validateProductGift = () => {
            const keyName = getKeyName(type)
            const result = {}
            Object.keys(benefitRedeemPointDetail[keyName]).forEach((i) => {
                if (FIELD_NAME_GIFT[i] && !benefitRedeemPointDetail[keyName][i]?.toString()) {
                    result[i] = `${FIELD_NAME_GIFT[i]} wajib diisi`
                } else if (i === 'quantity' && Number(benefitRedeemPointDetail[keyName][i]) <= 0) {
                    result[i] = `${FIELD_NAME_GIFT[i]} minimal 1`
                }
            })
            return Object.keys(result).length ? { [keyName]: result } : {}
        }

        return new Promise((resolve, reject) => {
            const fieldName = isFreeType(type) ? GET_FIELD_NAME : FIELD_NAME_DISCOUNT
            let errors = {}
            Object.keys(benefitRedeemPointDetail).forEach((key) => {
                if (fieldName[key] && !benefitRedeemPointDetail[key]?.toString()) {
                    errors[key] = `${fieldName[key]} wajib diisi`
                }
            })
            if (isFreeType(type)) errors = { ...errors, ...validateProductGift() }

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const getErrors = (errors, type) => {
        const error = convertErrorMessage(errors, { ...FIELD_NAME_DISCOUNT, ...FIELD_NAME_GIFT })
        const { benefit_id, quantity, ...errorRest } = error
        const newError = {
            ...errorRest,
            ...(isFreeType(type) && { gift: { benefit_id, quantity } }),
        }
        return newError
    }

    const onSubmit = () => {
        validateForm().then(() => {
            const { id, status, type, gift, discount_amount, ...detailRest } = benefitRedeemPointDetail
            const newKey = isFreeType(type?.value) ? 'benefit_id' : 'discount_amount'
            const newBenefit = { gift, discount_amount }
            const payload = {
                ...detailRest,
                type: type?.value,
                [newKey]: newBenefit.gift?.benefit_id?.value || newBenefit[getKeyName(type?.value)],
                ...(isFreeType(type?.value) && { quantity: newBenefit.gift?.quantity }),
            }

            if (!id) {
                createBenefit(payload)
                    .then(() => {
                        setShowAlert('Benefit Created !', { form: false })
                        fetchBenefitRedeemPointList()
                    })
                    .catch((error) => setErrorForm(getErrors(error?.data, type?.value)))
            } else {
                updateBenefit(payload, id)
                    .then(() => {
                        setShowAlert('Benefit Updated !', { form: false })
                        fetchBenefitRedeemPointList()
                    })
                    .catch((error) => setErrorForm(getErrors(error?.data, type?.value)))
            }
        })
    }

    const props = {
        dataList: benefitList?.data,
        modal,
        setShowModal,
        query,
        queryFilter,
        onChangeQuery,
        onFilter,
        selectedIds,
        onDelete,
        onSelectItemHandler,
        onActionRow,
        onChangeForm,
        options,
        onSearchOptions,
        onSubmit,
        onHideForm,
        errorForm,
        isResetSelectedItem,
        benefitRedeemPointDetail,
        isLoading,
        isDeleting,
        isCreating,
        isUpdating,
    }

    return <BenefitRedeemPoint {...props} />
}
